export default "__VITE_ASSET__DVwmstFl__"